export const exchangeRateDecimalPoint = 4;

export const WHO_PAYS_TYPE_YOU = 'DEBT';
export const WHO_PAYS_TYPE_RECIPIENT = 'CRED';
export const WHO_PAYS_TYPE_SHARED = 'SHAR';
export const whoPaysMapping = [
	{
		id: WHO_PAYS_TYPE_YOU,
		label: 'You',
		type: 'paid by you',
	},
	{
		id: WHO_PAYS_TYPE_RECIPIENT,
		label: 'The Recipient',
		type: 'paid by payee',
	},
	{
		id: WHO_PAYS_TYPE_SHARED,
		label: 'Shared',
		type: 'shared',
	},
];

export const eeaSharedOnlyCurrencies = ['BGN', 'CZK', 'DKK', 'HUF', 'HRK', 'NOK', 'PLN', 'RON', 'GBP', 'SEK', 'EUR'];
export const IFT_OVER_LIMIT_ERROR_CODE = '1003';
export const IFT_CHAIN_BUILD_ERROR_CODE = '40141';
export const IFT_DIFFERENT_CURRENCY_ERROR_CODE = '3104';
export const IFT_EXCEEDS_PREBOOKED_LIMIT_ERROR_CODE = '1005';

export const iftFormValidationLength = {
	preBookReferenceLength: '6',
	iftPaymentsReasonLength: '140',
};

export const treasuryNumber = '0800 121 4209';
